import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSidebarFloating: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="sidebar-floating, floating-window"><path fillRule="evenodd" clipRule="evenodd" d="M18.25 4C20.3211 4 22 5.67893 22 7.75V16.25C22 18.3211 20.3211 20 18.25 20H5.75C3.67893 20 2 18.3211 2 16.25V7.75C2 5.67893 3.67893 4 5.75 4H18.25ZM14.5 10.5V16.5H18.5V10.5H14.5Z" fill="currentColor"/></CentralIconBase>;
};

export default IconSidebarFloating;
